import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/admin/widgets',
    name: 'adminWidgets',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "widgets" */ './views/widgets.vue')
      ),
    meta: {
      authRequired: true,
    },
  },
]
